/**makeSelectLogs
 * Combine all reducers in this file and export the combined reducers.
 */

import {combineReducers} from 'redux';
import {connectRouter} from 'connected-react-router';
import history from '../utils/history';

import {State as LoginState} from '../pages/login/interfaces';
import {State as OrderState} from '../pages/orders/interfaces';
import {State as FleetState} from '../pages/fleets/interfaces';
import {State as BundleState} from '../pages/bundles/interfaces';
import {State as DriverState} from '../pages/drivers/interfaces';
import {State as UserState} from '../pages/users/interfaces';

import LoginReducer from '../pages/login/reducer';
import OrdersReducer from '../pages/orders/reducer';
import BundlesReducer from '../pages/bundles/reducer';
import DriversReducer from '../pages/drivers/reducer';
import UsersReducer from '../pages/users/reducer';
import FleetsReducer from '../pages/fleets/reducer';

export interface Store {
  login: LoginState;
  orders: OrderState;
  fleets: FleetState;
  bundles: BundleState;
  drivers: DriverState;
  users: UserState;
  router: any;
}

export default combineReducers<Store>({
  login: LoginReducer,
  orders: OrdersReducer,
  fleets: FleetsReducer,
  bundles: BundlesReducer,
  drivers: DriversReducer,
  users: UsersReducer,
  router: connectRouter(history),
});
